import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { LoginComponentProps } from '../../types/LoginFormData';
import { TSPCategory, TSPConfig } from '../types';

const roadEazyConfig: TSPConfig = {
  key: 'roadeazy',
  name: 'RoadEazy',
  category: TSPCategory.API_KEY,
  helpText: 'Enter your RoadEazy API key to connect your account.',
  loginComponent: (props: LoginComponentProps) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'API Key',
          name: 'apikey',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default roadEazyConfig;
